import { render } from "./DictionaryPage.vue?vue&type=template&id=a646ec82&ts=true"
import script from "./DictionaryPage.vue?vue&type=script&lang=ts"
export * from "./DictionaryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__